import { usePermissions } from '../../../hooks/usePermissions'
import {
  ResidentUserAuthLevel,
  UserPermissionsRow,
} from '../../../../common/validations'

export type PermissionFeature =
  | 'payments'
  | 'terminateContract'
  | 'contractChanges'
  | 'contractDocument'

const hasFeaturePermission = (
  feature: PermissionFeature,
  permissions: UserPermissionsRow,
  authLevel: ResidentUserAuthLevel
) => {
  const isStronglyAuthenticated = authLevel === ResidentUserAuthLevel.STRONG

  switch (feature) {
    case 'payments':
      return (
        isStronglyAuthenticated &&
        (permissions.tenantRoles.includes('contractParty') ||
          permissions.tenantRoles.includes('payer'))
      )
    case 'terminateContract':
    case 'contractDocument':
      return (
        isStronglyAuthenticated &&
        permissions.tenantRoles.includes('contractParty')
      )
    case 'contractChanges':
      return isStronglyAuthenticated
    default:
      return false
  }
}

/** Whether the user may use a feature on the current contract */
export const useFeaturePermission = () => {
  const { permissions, authLevel } = usePermissions()

  return (feature: PermissionFeature) =>
    !!permissions && hasFeaturePermission(feature, permissions, authLevel)
}
